import React from "react";
import "./filter-buttons.css";

class FilterButtons extends React.Component {
  constructor(props) {
    super(props);
    this.filters = {
      //"Button Text": "CMS Value"
      "Collins Aerospace": "Collins",
      "Pratt & Whitney": "Pratt"
    }
    this.activeFilters = this.getFilterValues();
    this.noFilterMenus = ['Pre Flight'];
  }

  componentDidMount() {
    this.props.selectFilter(this.activeFilters);
  }

  getFilterValues() {
    let values = [];
    for (let key in this.filters) {
      values.push(this.filters[key]);
    }
    return values;
  }

  render() {
    return (
      !this.noFilterMenus.includes(this.props.hotspot?.Title) && <div id="filterButtons-wrapper">
        <div id="filterButtons">
          {Object.keys(this.filters).map(name => {
            return <div
              key={"filter_" + name}
              onClick={e => {
                const curVal = this.filters[e.target.textContent];
                const curIdx = this.activeFilters.indexOf(curVal);
                if (curIdx >= 0) {
                  this.activeFilters.splice(curIdx, 1);
                } else {
                  this.activeFilters.push(curVal);
                }
                this.props.selectFilter(this.activeFilters);
              }}
              className={this.props.filter?.includes(this.filters[name]) ? 'active' : ''}>
              {name}
            </div>
          })}
        </div>
      </div>
    );
  }
}

export default FilterButtons;
